import mixin from '@/mixin/index.js';
import calculatorLabels from "@/constants/labels/calculators.labels.js";
const _getInputNumber = mixin.methods._getNumber;
const _formatNumber = mixin.methods._formatNumber;
const _roundNumber = mixin.methods._roundNumber;

const transfusionBloodVolumeCalculate = function ({ animal, weight, currentHematocrit, intendedHematocrit, donorHematocrit }) {
    const mutiplier = [
        /* Dogs */
        90,
        /* Cats */
        60
    ]
    if (typeof currentHematocrit != 'string' || typeof intendedHematocrit != 'string' || typeof donorHematocrit != 'string') {
        return;
    }
    weight = _getInputNumber(weight);
    currentHematocrit = _getInputNumber(currentHematocrit);
    intendedHematocrit = _getInputNumber(intendedHematocrit);
    donorHematocrit = _getInputNumber(donorHematocrit);
    if (donorHematocrit <= 0) {
        return { type: 'error', description: 'O hematócrito do doador deve ser maior que zero.' };
    }
    if (intendedHematocrit <= currentHematocrit) {
        return { type: 'error', description: 'O hematócrito pretendido deve ser sempre maior que o hematócrito atual.' };
    }
    let response = intendedHematocrit - currentHematocrit;
    response = response / donorHematocrit;
    response = response * weight * mutiplier[animal];
    return _formatNumber(_roundNumber(response, 2)) + ' mL';
}
const transfusionBloodVolume = {
    name: 'Transfusão | Volume de Sangue',
    id: 'e6cd7d1688fc48df97d2d6eebf0b2526',
    classes: ['Transfusão'],
    premium: true,
    variables: [
        {
            name: 'Selecione o paciente',
            type: 'select-animal',
            placeholder: 'Selecione',
            id: 'animal',
            items: [
                'dog',
                'cat',
            ],
            default: 0
        },
        {
            name: 'Peso do paciente que receberá a transfusão (kg)',
            type: 'number',
            placeholder: 'Digite o peso',
            id: 'weight',
            default: 0,
            suffix: 'kg'
        },
        {
            name: 'Insira o hematócrito atual do paciente (%)',
            type: 'number',
            placeholder: 'Insira o volume',
            id: 'currentHematocrit',
            default: 0,
            suffix: '%'
        },
        {
            name: 'Insira o hematócrito pretendido do paciente (%)',
            type: 'number',
            placeholder: 'Insira o volume',
            id: 'intendedHematocrit',
            default: 0,
            suffix: '%'
        },
        {
            name: 'Insira o hematócrito do doador (%)',
            type: 'number',
            placeholder: 'Insira o volume',
            id: 'donorHematocrit',
            default: 0,
            suffix: '%'
        }
    ],
    calculate: transfusionBloodVolumeCalculate,
    responseLabel: "Resultado | Volume de Sangue a ser Transfundido",
    sections: [
        {
            "description": "Objetivos da Calculadora ",
            "objects": [
                {
                    "description": "Objetivo"
                },
                {
                    "objects": [
                        {
                            "description": "Calcular o volume de sangue total a ser transfundido.",
                            "objects": []
                        }
                    ]
                },
                {
                    "objects": [
                        {
                            "description": "Volume de Sangue a ser Transfundido = (Peso do Receptor) X  N  X  (Hematócrito Pretendido do Receptor - Hematócrito Atual do Receptor)/(Hematócrito do Doador)",
                            "objects": [
                                {
                                    "description": "N = 90 para cães."
                                },
                                {
                                    "description": "N = 60 para gatos."
                                }
                            ]
                        }
                    ],
                    "description": "Fórmula"
                }
            ]
        }
    ],
    references: [
        {
            "magazine": "Livro",
            "name": "Practical Transfusion Medicine for the Small Animal Practitioner | 2nd Edition",
            "link": "Não se aplica.",
            "level": "Não se aplica.",
            "year": "2016"
        },
        {
            "year": "2017",
            "link": "Não se aplica.",
            "magazine": "Livro | ISBN: 978-0323312110",
            "level": "Não se aplica.",
            "name": "Textbook of Veterinary Internal Medicine | 8th Edition"
        },
        {
            "year": "2017",
            "magazine": "Livro | ISBN: 978-0323320658",
            "name": "Veterinary Surgery: Small Animal | 2nd Edition",
            "link": "Não se aplica.",
            "level": "Não se aplica."
        },
        {
            "level": "3",
            "name": "Accuracy of formulas used to predict post-transfusion packed cell volume rise in anemic dogs",
            "year": "2012",
            "magazine": "J Vet Emerg Crit Care (San Antonio).",
            "link": "https://pubmed.ncbi.nlm.nih.gov/22805336/"
        },
        {
            "level": "Review não sistemático.",
            "year": "2020",
            "magazine": "Veterinary Clinics of North America: Small Animal Practice",
            "name": "Small Animal Transfusion Medicine",
            "link": "https://www.sciencedirect.com/science/article/abs/pii/S0195561620300589?via%3Dihub"
        },
        {
            "magazine": "Livro | ISBN: 978-1118933022",
            "name": "Manual of Veterinary Transfusion Medicine and Blood Banking | 1st Edition",
            "level": "Não se aplica",
            "year": "2016",
            "link": "Não se aplica."
        },
        {
            "name": "Canine and feline blood transfusions: controversies and recent advances in administration practices",
            "year": "2014",
            "link": "https://pubmed.ncbi.nlm.nih.gov/24576208/",
            "level": "Review não sistemático.",
            "magazine": "Vet Anaesth Analg."
        }
    ],
}
const transfusionBloodVolumeAndSpeed = {
    name: 'Transfusão | Volume de Sangue + Velocidade de Administração',
    id: calculatorLabels.TRANSFUSION_BLOOD_AND_SPEED_ID,
    classes: ['Transfusão'],
    premium: true,
    routeName: 'transfusion-volume-speed-calculator',
    transfusionBloodVolumeCalculate,
    sections: [
        {
            "description": "Objetivos da Calculadora ",
            "objects": [
                {
                    "description": "Objetivos"
                },
                {
                    "objects": [
                        {
                            "description": "Calcular o volume de sangue total a ser transfundido.",
                            "objects": []
                        },
                        {
                            "objects": [
                                {
                                    "description": "Período inicial de teste: primeiros 30 minutos."
                                },
                                {
                                    "description": "Após o período inicial de teste: após os primeiros 30 minutos."
                                }
                            ],
                            "description": "Calcular a velocidade de administração."
                        }
                    ]
                },
                {
                    "description": "Fórmula",
                    "objects": [
                        {
                            "description": "Volume de Sangue a ser Transfundido = (Peso do Receptor) X  N  X  (Hematócrito Pretendido do Receptor - Hematócrito Atual do Receptor)/(Hematócrito do Doador)",
                            "objects": [
                                {
                                    "description": "N = 90 para cães."
                                },
                                {
                                    "description": "N = 60 para gatos."
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    references: [
        {
            "name": "Practical Transfusion Medicine for the Small Animal Practitioner | 2nd Edition",
            "magazine": "Livro",
            "link": "Não se aplica.",
            "year": "2016",
            "level": "Não se aplica."
        },
        {
            "magazine": "Livro | ISBN: 978-0323312110",
            "level": "Não se aplica.",
            "name": "Textbook of Veterinary Internal Medicine | 8th Edition",
            "year": "2017",
            "link": "Não se aplica."
        },
        {
            "name": "Veterinary Surgery: Small Animal | 2nd Edition",
            "level": "Não se aplica.",
            "link": "Não se aplica.",
            "magazine": "Livro | ISBN: 978-0323320658",
            "year": "2017"
        },
        {
            "name": "Accuracy of formulas used to predict post-transfusion packed cell volume rise in anemic dogs",
            "year": "2012",
            "magazine": "J Vet Emerg Crit Care (San Antonio).",
            "link": "https://pubmed.ncbi.nlm.nih.gov/22805336/",
            "level": "3"
        },
        {
            "name": "Small Animal Transfusion Medicine",
            "magazine": "Veterinary Clinics of North America: Small Animal Practice",
            "level": "Review não sistemático.",
            "year": "2020",
            "link": "https://www.sciencedirect.com/science/article/abs/pii/S0195561620300589?via%3Dihub"
        },
        {
            "link": "Não se aplica.",
            "magazine": "Livro | ISBN: 978-1118933022",
            "name": "Manual of Veterinary Transfusion Medicine and Blood Banking | 1st Edition",
            "level": "Não se aplica",
            "year": "2016"
        },
        {
            "level": "Review não sistemático.",
            "year": "2014",
            "name": "Canine and feline blood transfusions: controversies and recent advances in administration practices",
            "magazine": "Vet Anaesth Analg.",
            "link": "https://pubmed.ncbi.nlm.nih.gov/24576208/"
        }
    ]
}
const donorMaximumBloodVolume = {
    name: 'Volume Máximo de Coleta de Sangue | Doador',
    id: 'a4b4986968574ff8b0b61d29ad978337',
    premium: true,
    classes: ['Transfusão'],
    variables: [
        {
            name: 'Selecione o paciente',
            type: 'select-animal',
            placeholder: 'Selecione',
            id: 'animal',
            items: [
                'dog',
                'cat',
            ],
            default: 0
        },
        {
            name: 'Peso em quilogramas',
            type: 'number',
            placeholder: 'Peso',
            id: 'weight',
            default: 0,
            suffix: 'kg'
        }
    ],
    calculate: function ({ animal, weight }) {
        const formulas = [
            /* Dogs */
            function (weight) {
                const initialValue = _formatNumber(_roundNumber((weight * 15), 2));
                const finalValue = _formatNumber(_roundNumber((weight * 20), 2));
                return `${initialValue} - ${finalValue} mL`;
            },
            /* Cats */
            function (weight) {
                const initialValue = _formatNumber(_roundNumber((weight * 10), 2));
                const finalValue = _formatNumber(_roundNumber((weight * 15), 2));
                return `${initialValue} - ${finalValue} mL`;
            }
        ]
        weight = weight || '0';
        weight = new Number(weight.replace(',', '.'));
        return formulas[animal](weight);
    },
    responseLabel: "Resultado | Volume Máximo de Coleta",
    sections: [
        {
            "description": "Objetivos da Calculadora ",
            "objects": [
                {
                    "objects": [
                        {
                            "objects": [
                                {
                                    "description": "Volume de doação considerado seguro para cães: 15 a 20 mL/kg."
                                },
                                {
                                    "description": "Volume de doação considerado seguro para gatos: 10 a 15 mL/kg."
                                }
                            ],
                            "description": "Calcular uma faixa de volume máximo de coleta de sangue, considerada segura."
                        },
                        {
                            "objects": [
                                {
                                    "description": "Os valores supracitados partem do pressuposto que o doador esteja hígido."
                                }
                            ],
                            "description": "Atenção:"
                        }
                    ]
                }
            ]
        }
    ],
    references: [
        {
            "link": "https://www.sciencedirect.com/science/article/abs/pii/S0195561620300589?via%3Dihub",
            "name": "Small Animal Transfusion Medicine",
            "year": "2020",
            "level": "Review não sistemático.",
            "magazine": "Veterinary Clinics of North America: Small Animal Practice "
        },
        {
            "magazine": "Livro",
            "level": "Não se aplica.",
            "link": "Não se aplica.",
            "year": "2016",
            "name": "Practical Transfusion Medicine for the Small Animal Practitioner | 2nd Edition "
        }
    ],
}

export default {
    transfusionBloodVolumeAndSpeed,
    transfusionBloodVolume,
    donorMaximumBloodVolume
}